// extracted by mini-css-extract-plugin
module.exports = {"container":"ReoccurringInfoPage_container__2Vyo7","listWrapper":"ReoccurringInfoPage_listWrapper__1dCuJ","noDataText":"ReoccurringInfoPage_noDataText__2Wiau"};